import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, CheckCircle2, Clock, Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LocationSelect, useLocations } from "@/components/LocationSelect";
import { TaskProgress } from "@/components/TaskProgress";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";

export default function Inicio() {
  const { user } = useAuth();
  const { activeLocation } = useLocations();
  const [controls, setControls] = useState([]);

  useEffect(() => {
    if (!activeLocation) return;
    api.get(`/controls/today?location_id=${activeLocation}`)
      .then(({ data }) => setControls(data))
      .catch(() => setControls([]));
  }, [activeLocation]);

  const done = controls.filter((c) => c.status === "COMPLETED" || c.status === "INCIDENT").length;
  const pending = controls.filter((c) => ["PENDING", "LATE"].includes(c.status)).length;
  const outOfRange = controls.filter((c) => c.status === "INCIDENT").length;

  return (
    <div className="px-4 pt-5">
      <p className="text-sm text-slate-500">{fmtDate(new Date())}</p>
      <h1 className="font-display text-2xl font-semibold tracking-tight">Hola, {user?.name?.split(" ")[0]}</h1>
      <div className="mt-3"><LocationSelect /></div>

      <div className="mt-5"><TaskProgress compact /></div>

      <div className="mt-5 grid grid-cols-3 gap-3">
        <StatBox icon={Clock} label="Pendientes" value={pending} tone="amber" testid="stat-pendientes" />
        <StatBox icon={CheckCircle2} label="Realizados" value={done} tone="emerald" testid="stat-realizados" />
        <StatBox icon={Bell} label="Fuera rango" value={outOfRange} tone="red" testid="stat-alertas" />
      </div>

      <Link to="/app/planillas">
        <Button data-testid="inicio-planillas-btn" variant="outline" className="mt-5 h-14 w-full rounded-2xl border-[#2563EB]/30 text-base text-[#2563EB]">
          <ClipboardList className="mr-2 h-5 w-5" /> Planillas del día
        </Button>
      </Link>
    </div>
  );
}

function StatBox({ icon: Icon, label, value, tone, testid }) {
  const tones = { amber: "text-amber-600", emerald: "text-emerald-600", red: "text-red-600" };
  return (
    <div data-testid={testid} className="rounded-2xl border border-slate-200 bg-white p-3 text-center">
      <Icon className={`mx-auto h-5 w-5 ${tones[tone]}`} />
      <p className="tnum mt-1 font-display text-2xl font-semibold">{value}</p>
      <p className="text-[11px] text-slate-500">{label}</p>
    </div>
  );
}
